import {HttpErrorResponse, HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {retry, tap, timer} from "rxjs";
import {inject, ErrorHandler} from "@angular/core";

export const retryGetInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandler);

  const forwardError = tap<HttpEvent<unknown>>({
    error: (error: unknown) => {
      if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
        return;
      }
      errorHandler.handleError(error);
    }
  });

  if (req.method !== 'GET') {
    return next(req).pipe(forwardError);
  }

  return next(req)
    .pipe(
      retry({
        count: 3,
        delay: (error, retryCount) => timer(500 * retryCount)
      }),
      forwardError,
    );
};
